import { withErrorBoundary } from "@sentry/nextjs";
import cn from "classnames";
import { FC, ReactNode } from "react";
import styled from "styled-components";

interface Props {
  children: ReactNode;
  className?: string;
  color?: "Color_dusk70" | "Color_secondary" | "Color_eucalyptus80";
}

const SupTitle: FC<Props> = withErrorBoundary(({ className = "", color = "Color_dusk70", children }) => {
  return (
    <StyledSupTitle
      className={cn("Font_18_26_700", className, {
        Color_dusk70: color === "Color_dusk70",
        Color_secondary: color === "Color_secondary",
        Color_eucalyptus80: color === "Color_eucalyptus80",
      })}
    >
      {children}
    </StyledSupTitle>
  );
}, {});

const StyledSupTitle = styled.h3`
  display: flex;
  align-items: center;

  &::before {
    content: "";
    width: 40px;
    height: 2px;
    background-color: ${({ theme }) => theme.colors.dusk["70"]};
    margin-right: 8px;
  }

  &.Color_secondary::before {
    width: 64px;
    background-color: ${({ theme }) => theme.colors.fog["60"]};
    margin-right: 16px;
  }

  &.Color_eucalyptus80::before {
    width: 40px;
    background-color: ${({ theme }) => theme.colors.eucalyptus["80"]};
    margin-right: 16px;
  }
`;

export { SupTitle };
